import * as React from 'react';

import {isSafeUrlPath} from 'nutshell-core/utils/is-safe-url-path';

import {SubdomainSelect} from '../subdomain-select/subdomain-select';
import type {SubdomainOption} from '../subdomain-select/subdomain-select';
import {TextField} from '../textfield/textfield';
import {Body} from '../typography/body';

import styles from './subdomain-slug-field.module.css';

type Props = {
    subdomainOptions: SubdomainOption[];
    selectedSubdomain: SubdomainOption | null | undefined;
    slug: string;
    slugPlaceholder?: string;
    errorMessage?: string | null | undefined;
    onSlugChange: (slug: string) => void;
    onSelectedSubdomainChange: (option: SubdomainOption) => void;
};

export function SubdomainSlugField(props: Props) {
    return (
        <div className={styles.grid}>
            <div className={styles.container}>
                <SubdomainSelect
                    options={props.subdomainOptions}
                    selectedOption={props.selectedSubdomain}
                    // @ts-expect-error
                    onSelectOption={props.onSelectedSubdomainChange}
                    disableUnverifiedOptions={true}
                    noBorder={true}
                    isClearable={false}
                />
                <div className={styles.textfield}>
                    <TextField
                        placeholder={props.slugPlaceholder}
                        value={props.slug}
                        onChange={(newPath) => {
                            // No spaces, other URL safety validated on backend
                            const safePath = newPath.replace(' ', '');
                            if (isSafeUrlPath(safePath)) {
                                props.onSlugChange(safePath);
                            }
                        }}
                        noBorder={true}
                    />
                </div>
            </div>
            {props.errorMessage && (
                <div className={styles['error-message']}>
                    <Body color='error' size='small'>
                        {props.errorMessage}
                    </Body>
                </div>
            )}
        </div>
    );
}
